import { emit, emitter, EmitterEvent } from '@store/events';
import ky from 'ky';

export function basketAddProductHandler() {
  emitter.on(EmitterEvent.BasketReload, async (widgetUrl: string) => {
    const response = await ky.get(widgetUrl);
    if (response.ok) {
      const html = await response.text();
      const widgetElement = document.getElementById('shopping-basket-widget');
      if (widgetElement) {
        widgetElement.innerHTML = html;
      }
    }
  });

  document.addEventListener('submit', async event => {
    const target = event.target as HTMLFormElement;
    if (!target.matches('[data-id="addToBasket"]')) return;

    event.preventDefault();

    const fd = new FormData(target);

    const response = await ky.post(target.action, {
      body: fd,
      throwHttpErrors: false,
    });

    if (response.ok) {
      const json = await response.json();
      if (json.notification) emit.alert(json.notification);
      if (json.widgetUrl) emit.basket.reload(json.widgetUrl);
    }
  });
}
